import React from "react";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import LocalMallRoundedIcon from "@mui/icons-material/LocalMallRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import WidgetsIcon from "@mui/icons-material/Widgets";
import CategoryIcon from "@mui/icons-material/Category";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import StoreSharpIcon from "@mui/icons-material/StoreSharp";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import OutputIcon from "@mui/icons-material/Output";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TableRowsIcon from "@mui/icons-material/TableRows";
import WindowIcon from "@mui/icons-material/Window";
import ReorderIcon from "@mui/icons-material/Reorder";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchIcon from "@mui/icons-material/Search";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import EastIcon from "@mui/icons-material/East";
import { useUser } from "../../shared/context/UserContext";
import { ChevronLeft } from "lucide-react";
import { colorOptions } from "src/shared/modules/profile/theme/themeConstants";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ScaleIcon from "@mui/icons-material/Scale";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import EventNoteIcon from "@mui/icons-material/EventNote";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import BadgeIcon from "@mui/icons-material/Badge";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import ContrastIcon from "@mui/icons-material/Contrast";
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import SyncIcon from '@mui/icons-material/Sync';

const Menubar = ({ IconComponent }: { IconComponent: React.ElementType }) => {
  const { user } = useUser();
  return (
    <IconComponent
      className={`${colorOptions[user?.themes.backgroundColour || "DodgerBlue"]}`}
      style={{ fontSize: "35px", color: user?.themes.backgroundColour }}
    />
  );
};
const Setting = ({ IconComponent }: { IconComponent: React.ElementType }) => {
  return <IconComponent className='text-gray-300 hover:text-black cursor-pointer' style={{ fontSize: "35px" }} />;
};
const Small = ({ IconComponent }: { IconComponent: React.ElementType }) => {
  return <IconComponent style={{ color: "black", fontSize: "30px" }} />;
};
const Icons = ({ IconComponent }: { IconComponent: React.ElementType }) => {
  return <IconComponent style={{ color: "white", fontSize: "40px" }} />;
};

const Black = ({ IconComponent }: { IconComponent: React.ElementType }) => {
  return <IconComponent style={{ color: "black", fontSize: "40px" }} />;
};

const Red = ({ IconComponent }: { IconComponent: React.ElementType }) => {
  return <IconComponent style={{ color: "red", fontSize: "25px" }} />;
};

const GroMenu = ({ IconComponent }: { IconComponent: React.ElementType }) => {
  return <IconComponent style={{ fontSize: "35px" }} />;
};
const GroEdit = ({ IconComponent }: { IconComponent: React.ElementType }) => {
  return <IconComponent style={{ fontSize: "25px" }} />;
};
const ButtonIcons = ({ IconComponent }: { IconComponent: React.ElementType }) => {
  return <IconComponent style={{ color: "white", fontSize: "24px" }} />;
};

const iconMap = {
  home: () => <GroMenu IconComponent={HomeRoundedIcon} />,
  reports: () => <GroMenu IconComponent={EventNoteIcon} />,
  Inventory: () => <Menubar IconComponent={Inventory2Icon} />,
  products: () => <GroMenu IconComponent={LocalMallRoundedIcon} />,
  settings: () => <GroMenu IconComponent={SettingsRoundedIcon} />,
  logout: () => <Setting IconComponent={LogoutRoundedIcon} />,
  Dashboard: () => <GroMenu IconComponent={DashboardIcon} />,
  ReturnOrder: () => <GroMenu IconComponent={AssignmentReturnedIcon} />,
  wallet: () => <GroMenu IconComponent={AccountBalanceWalletRoundedIcon} />,
  menu: () => <Icons IconComponent={MenuTwoToneIcon} />,
  profile: () => <Small IconComponent={AccountCircleIcon} />,
  customer: () => <GroMenu IconComponent={SupervisorAccountIcon} />,
  category: () => <GroMenu IconComponent={CategoryIcon} />,
  uom: () => <GroMenu IconComponent={ScaleIcon} />,
  configration: () => <GroMenu IconComponent={ToggleOffIcon} />,
  product: () => <GroMenu IconComponent={WidgetsIcon} />,
  employee: () => <GroMenu IconComponent={BadgeIcon} />,
  SharpIcon: () => <Small IconComponent={StoreSharpIcon} />,
  addIcon: () => <Menubar IconComponent={AddIcon} />,
  close: () => <Small IconComponent={CloseIcon} />,
  open: () => <Black IconComponent={ArrowDropDownIcon} />,
  down: () => <ButtonIcons IconComponent={ArrowDropDownIcon} />,
  blackDown: () => <GroMenu IconComponent={ArrowDropDownIcon} />,
  Edit: () => <Menubar IconComponent={EditIcon} />,
  Delete: () => <Red IconComponent={DeleteIcon} />,
  SearchIcon: () => <Setting IconComponent={SearchIcon} />,
  Deleteicon: () => <Icons IconComponent={DeleteIcon} />,
  InputIcon: () => <Black IconComponent={NavigateBeforeIcon} />,
  OutputIcon: () => <Setting IconComponent={OutputIcon} />,
  WarehouseIcon: () => <Setting IconComponent={WarehouseIcon} />,
  CallReceivedIcon: () => <Setting IconComponent={CallReceivedIcon} />,
  TableRowsIcon: () => <Setting IconComponent={TableRowsIcon} />,
  WindowIcon: () => <Setting IconComponent={WindowIcon} />,
  ReorderIcon: () => <Setting IconComponent={ReorderIcon} />,
  ArrowBackIcon: () => <Setting IconComponent={ChevronLeft} />,
  EastIcon: () => <Black IconComponent={EastIcon} />,
  EditGro: () => <GroEdit IconComponent={EditIcon} />,
  Back: () => <GroMenu IconComponent={KeyboardBackspaceIcon} />,
  BarcodeReaderIcon: () => <GroMenu IconComponent={QrCode2Icon} />,
  Sync: () => <Small IconComponent={SyncIcon} />,
  configuration: () => <GroMenu IconComponent={ManageAccountsIcon} />,
  myProfile: () => <GroMenu IconComponent={PermIdentityIcon} />,
  theme: () => <GroMenu IconComponent={ContrastIcon} />,
};

export default iconMap;
